import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';

@Pipe({
  name: 'orderByTime'
})
export class OrderByTimePipe implements PipeTransform {

  transform( value: any, args?: any): any {
    return _.sortBy( value, [ ( item ) => _.get( item, 'time.hours', 0 ) ] );
  }
}



// WEBPACK FOOTER //
// ./src/app/order-by-time.pipe.ts